import * as yup from "yup";
import { Max, Patterns, Validation } from "../../utils/Validation.utils";
export const PriorityPublicInviteInitialValues = {
    email: "",
    note: ""
};
export const PriorityPublicInviteSchema = yup.object().shape({
    email: yup
        .string()
        .required(Validation.Required)
        .matches(Patterns.Email, Validation.Invalid)
        .max(Max.Email, Validation.Max),
    note: yup.string().max(Max.Note, Validation.Max)
});
